<template>
  <div>
    <!--    Cabecera con parte del vídeo-->
    <section class="bg-primary py-5 bg-trama">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-12 text-white my-5">
            <h1>Esto es… nuestro Paseo del Prado</h1>
          </div>

          <div class="col-12">
            <p class="subtitular text-white">
              Madrid tiene una vida cultural apasionante, en la que tienen cabida tanto lo <em>mainstream</em> como lo
              <em>friki</em> o lo minoritario, y el epicentro de su cultura se encuentra en el Paseo del Prado, una de
              las vías con más arte pictórico por metro cuadrado de todo el mundo.
            </p>
            <p class="subtitular text-white">
              En la Sierra Norte de Madrid,
              <strong
                >los espacios dedicados a la cultura están mucho más diseminados por toda nuestra geografía.</strong
              >
              Pero todos tienen algo en común: ¡te van a sorprender y maravillar a partes iguales!
            </p>
          </div>

          <div class="col-12 mt-4">
            <img src="/img/icons/culturetas.svg" alt="Ruta especial para culturetas" class="mr-3" /><span
              class="text-black small"
              >Planes especiales para culturetas</span
            >
            <div class="w100 my-5"></div>
          </div>
        </div>
      </div>
    </section>

    <!--      Fin de cabecera-->
    <!--      Sección con scroll horizontal-->

    <div id="scroll-wrapper" class="container-fluid scroll-wrapper bg-light">
      <div id="scrollContainer" class="scroll-sections">
        <div id="fondo-puntos" style="overflow: hidden;width:50px;position:absolute;height: 100vh;left:900px">
          <img src="/img/caminos/camino-1.svg" alt="" style="position: absolute;top:30%;z-index:2" />
        </div>

        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <h2 class="mb-4">Cultura accesible</h2>
            <p class="subtitular z-index-up">
              Es probable que lo más reconocible de la Sierra Norte de Madrid sean sus parajes naturales y sus casitas
              de piedra, pero esta zona tiene mucho más que ofrecer.
              <strong
                >Visita nuestras iglesias o nuestros museos, y descubre otro Madrid con una vida cultural que no
                esperas.</strong
              >
            </p>
            <a href="https://www.sierranortemadrid.org/restaurantes/" class="btn btn-primary mr-3 mt-2" target="_blank">
              ¿Dónde comer?
            </a>
            <a href="https://www.sierranortemadrid.org/alojamiento/" class="btn btn-primary mt-2" target="_blank">
              ¿Dónde alojarse?
            </a>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta7/museo-picasso.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Museo Picasso</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¿Sabías que en Madrid es posible ver un museo dedicado a la figura de uno de los pintores
                      españoles más relevantes de todos los tiempos?
                      <a
                        href="https://www.sierranortemadrid.org/museo-picasso-buitrago/"
                        target="_blank"
                        alt="Más información sobre el Museo Picasso de Buitrago"
                        >El Museo Picasso - Colección Arias de Buitrago del Lozoya</a
                      >
                      del Lozoya se compone de una nutrida colección de obras que el pintor le regaló a su barbero y
                      amigo Eugenio Arias, ciudadano de Buitrago. En total se trata de
                      <strong>65 obras, compuestas por cerámicas, litografías, carteles, dibujos y aguadas.</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      La colección fue cedida por Eugenio Arias a la diputación de Madrid en 1982, respondiendo a su
                      deseo de crear una colección monográfica en su pueblo natal, y
                      <strong>se encuentra en las instalaciones del Ayuntamiento de Buitrago.</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      Consejos adicionales: si quieres dejar el coche aparcado en casa, puedes llegar en autobús desde
                      Plaza de Castilla.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-todas-estaciones />
                  <icon-parejas />
                  <icon-influencers />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Museo Picasso</h3>

                <p>
                  ¿Sabías que en Madrid es posible visitar un museo dedicado a la figura del artista malagueño?
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal1 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-todas-estaciones />
                  <icon-parejas />
                  <icon-influencers />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Inicio "2" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta7/museo-de-vargas.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Museo De Vargas</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      En 2018 se inauguró en Horcajuelo de la Sierra un
                      <a
                        href="https://www.sierranortemadrid.org/fundacion-devargas/"
                        target="_blank"
                        alt="Más información sobre el Museo de Vargas"
                        >Museo dedicado a la figura de Ramón de Vargas,</a
                      >
                      pintor de fama internacional, con <strong>más de 40 obras del artista vizcaíno.</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      Puede visitarse viernes y sábados, en horarios de mañana y tarde; y domingos y festivos, por la
                      mañana.
                    </span>
                  </li>
                  <li>
                    <span>
                      Consejos adicionales:
                      <strong
                        >ya que visitas Horcajuelo, no te pierdas la Iglesia de San Nicolás de Bari, ni su museo
                        etnográfico.</strong
                      >
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-todas-estaciones />
                  <icon-parejas />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Museo De Vargas</h3>

                <p>
                  ¿Te conoces de pé a pá el Prado, el Thyssen o el Reina Sofía? ¡En Madrid hay muchos museos que
                  visitar!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal2 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-todas-estaciones />
                  <icon-parejas />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta7/convento-san-antonio.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Convento de San Antonio</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/convento-san-antonio"
                        target="_blank"
                        alt="Más información sobre el convento de San Antonio"
                        >Este convento de estilo románico,</a
                      >
                      que probablemente data del siglo XI, se encuentra en la sierra de La Cabrera, en la ladera del
                      Cancho Gordo.
                    </span>
                  </li>
                  <li>
                    <span>
                      Su elemento arquitectónico más importante es su iglesia, aunque también
                      <strong>merecen mención aparte sus jardines, salpicados de fuentes y estanques.</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      Solo se puede acceder durante las visitas guiadas que hacen los propios monjes, los domingos en
                      horario de misa o en eventos especiales, como conciertos.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-aventureros />
                  <icon-todas-estaciones />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Convento de San Antonio</h3>

                <p>
                  Los perseguidores de la belleza y la introspección tenéis una parada obligatoria en La Cabrera.
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal3 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-aventureros />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "2" slider ******************-->
        <!--          Inicio "3" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta7/iglesia-san-vicente-martir.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Iglesia de San Vicente Mártir</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/planes/iglesia-braojos"
                        target="_blank"
                        alt="Más información sobe la iglesia de San Vicente Mártir"
                        >La iglesia de San Vicente Mártir</a
                      >
                      de Braojos encierra <strong>cuatro retablos de madera sobredorada de enorme valor,</strong> con
                      esculturas del artista Gregorio Fernández y pinturas de Vicente Carducho.
                    </span>
                  </li>
                  <li>
                    <span>
                      <strong>Es posible realizar visitas guiadas los fines de semana,</strong> siempre con reserva
                      previa. Los días de diario es necesario consultar disponibilidad con la oficina de turismo de
                      Braojos.
                    </span>
                  </li>
                  <li>
                    <span>
                      Consejo adicional: no te pierdas la Ermita del Buen Suceso, a solo 1 km. de distancia.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="45m" />
                  <icon-parejas />
                  <icon-todas-estaciones />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Iglesia de San Vicente Mártir</h3>
                <p>
                  Si quieres descubrir un pequeño tesoro cultural, ¡no te pierdas la Iglesia de san Vicente Mártir de
                  Braojos!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal4 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="45m" />
                  <icon-parejas />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta7/iglesia-magdalena-torrelaguna.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Iglesia de la Magdalena (Villa de Madrid)</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/torrelaguna-cuna-de-cisneros/(plan)"
                        target="_blank"
                        alt="La iglesia de la Magdalena"
                        >La iglesia parroquial de Santa María de la Magdalena,</a
                      >
                      en Torrelaguna, es un edificio de estilo gótico construido en el siglo XIV.
                      <strong>No te pierdas su impresionante retablo ni las lápidas,</strong> que puedes encontrar por
                      todo el suelo de la iglesia.
                    </span>
                  </li>
                  <li>
                    <span>
                      Consejos adicionales: Puedes llegar en autobús desde Plaza Castilla ( Linea 197); En las afueras
                      del pueblo se encuentran la ermita barroca de Santa María de la Cabeza, residencia y tumba de la
                      santa antes de que trasladaran sus restos a Madrid, y la ermita de la Virgen de la Soledad (del
                      siglo XVIII).
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="30m" />
                  <icon-todas-estaciones />
                  <icon-foodies />
                  <icon-parejas />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Iglesia de la Magdalena (Villa de Madrid)</h3>

                <p>
                  La cuna del cardenal Cisneros tiene mucho que ofrecer, ¡como su famosa iglesia de la Magdalena!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal5 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="30m" />
                  <icon-todas-estaciones />
                  <icon-foodies />
                  <icon-parejas />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "3" slider ******************-->

        <!--          Inicio "4" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top my-5 my-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up ">
                <img src="/img/rutas/ruta7/arqueologico.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none mb-4">
                <h3 class="mt-5 mb-3">Parque Arqueológico del Valle de los Neandertales (Pinilla del Valle)</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/visita-valle-de-los-neandertales/"
                        target="_blank"
                        alt="Más información sobre el Valle de los Neandertales"
                        >El Valle de los Neandertales</a
                      >
                      tiene como principal objetivo estudiar los yacimientos arqueopaleontológicos descubiertos en el
                      Valle Alto del río Lozoya. Se trata de un
                      <strong
                        >conjunto de siete yacimientos cársticos con cronologías que abarcan desde el último tercio del
                        Pleistoceno Medio hasta mediados del Pleistoceno Superior.</strong
                      >
                    </span>
                  </li>
                  <li>
                    <span>
                      Estos yacimientos contienen
                      <strong
                        >registros tanto de los animales y la flora como de los humanos que vivieron en el Valle hace
                        100.000 años.</strong
                      >
                    </span>
                  </li>
                  <li>
                    <span>
                      Puede visitarse de martes a domingo, desde por la mañana hasta primera hora de la tarde. Cierra
                      entre agosto y septiembre, durante las campañas de excavación.
                    </span>
                  </li>
                  <li>
                    <span>
                      Consejo adicional: es <strong>imprescindible reservar plaza previamente,</strong> y acudir al
                      punto de encuentro 15 minutos antes de la visita.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-aventureros />
                  <icon-familias />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Parque Arqueológico del Valle de los Neandertales (Pinilla del Valle)</h3>

                <p>
                  ¡Sigue las huellas de nuestros antepasados para conocer cómo era la vida en Madrid hace miles de años!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal6 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-aventureros />
                  <icon-familias />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "4" slider ******************-->
      </div>
    </div>
    <!--    Fin sección scroll horizontal-->

    <!--    Inicio modals-->

    <!--   Inicio Modal 1-->
    <b-modal id="modal1" centered scrollable size="lg" hide-footer title="Museo Picasso">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/museo-picasso-buitrago/"
                  target="_blank"
                  alt="Más información sobre el Museo Picasso de Buitrago"
                  >El Museo Picasso - Colección Arias de Buitrago del Lozoya</a
                >
                se compone de una nutrida colección de obras que el pintor le regaló a su barbero y amigo Eugenio Arias,
                ciudadano de Buitrago. En total se trata de
                <strong>65 obras, compuestas por cerámicas, litografías, carteles, dibujos y aguadas.</strong>
              </span>
            </li>
            <li>
              <span>
                La colección fue cedida por Eugenio Arias a la diputación de Madrid en 1982, respondiendo a su deseo de
                crear una colección monográfica en su pueblo natal, y
                <strong>se encuentra en las instalaciones del Ayuntamiento de Buitrago.</strong>
              </span>
            </li>
            <li>
              <span>
                Consejos adicionales: si quieres dejar el coche aparcado en casa, puedes llegar en autobús desde Plaza
                de Castilla.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 1-->
    <!--   Inicio Modal 2-->
    <b-modal id="modal2" centered scrollable size="lg" hide-footer title="Museo de Vargas">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                En 2018 se inauguró en Horcajuelo de la Sierra un
                <a
                  href="https://www.sierranortemadrid.org/fundacion-devargas/"
                  target="_blank"
                  alt="Más información sobre el Museo de Vargas"
                  >Museo dedicado a la figura de Ramón de Vargas,</a
                >
                pintor de fama internacional, con <strong>más de 40 obras del artista vizcaíno.</strong>
              </span>
            </li>
            <li>
              <span>
                Puede visitarse viernes y sábados, en horarios de mañana y tarde; y domingos y festivos, por la mañana.
              </span>
            </li>
            <li>
              <span>
                Consejos adicionales:
                <strong
                  >ya que visitas Horcajuelo, no te pierdas la Iglesia de San Nicolás de Bari, ni su museo
                  etnográfico.</strong
                >
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 2-->
    <!--   Inicio Modal 3-->
    <b-modal id="modal3" centered scrollable size="lg" hide-footer title="Convento de San Antonio">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/convento-san-antonio"
                  target="_blank"
                  alt="Más información sobre el convento de San Antonio"
                  >Este convento de estilo románico,</a
                >
                que probablemente data del siglo XI, se encuentra en la sierra de La Cabrera, en la ladera del Cancho
                Gordo.
              </span>
            </li>
            <li>
              <span>
                Su elemento arquitectónico más importante es su iglesia, aunque también
                <strong>merecen mención aparte sus jardines, salpicados de fuentes y estanques.</strong>
              </span>
            </li>
            <li>
              <span>
                Solo se puede acceder durante las visitas guiadas que hacen los propios monjes, los domingos en horario
                de misa o en eventos especiales, como conciertos.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 3-->
    <!--   Inicio Modal 4-->
    <b-modal id="modal4" centered scrollable size="lg" hide-footer title="Iglesia de San Vicente Mártir">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/planes/iglesia-braojos"
                  target="_blank"
                  alt="Más información sobe la iglesia de San Vicente Mártir"
                  >La iglesia de San Vicente Mártir</a
                >
                de Braojos encierra <strong>cuatro retablos de madera sobredorada de enorme valor,</strong> con
                esculturas del artista Gregorio Fernández y pinturas de Vicente Carducho.
              </span>
            </li>
            <li>
              <span>
                <strong>Es posible realizar visitas guiadas los fines de semana,</strong> siempre con reserva previa.
                Los días de diario es necesario consultar disponibilidad con la oficina de turismo de Braojos.
              </span>
            </li>
            <li>
              <span>
                Consejo adicional: no te pierdas la Ermita del Buen Suceso, a solo 1 km. de distancia.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 4-->
    <!--   Inicio Modal 5-->
    <b-modal id="modal5" centered scrollable size="lg" hide-footer title="Iglesia de la Magdalena (Villa de Madrid)">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/torrelaguna-cuna-de-cisneros/(plan)"
                  target="_blank"
                  alt="La iglesia de la Magdalena"
                  >La iglesia parroquial de Santa María de la Magdalena,</a
                >
                en Torrelaguna, es un edificio de estilo gótico construido en el siglo XIV.
                <strong>No te pierdas su impresionante retablo ni las lápidas,</strong> que puedes encontrar por todo el
                suelo de la iglesia.
              </span>
            </li>
            <li>
              <span>
                Consejos adicionales: Puedes llegar en autobús desde Plaza Castilla ( Linea 197); En las afueras del
                pueblo se encuentran la ermita barroca de Santa María de la Cabeza, residencia y tumba de la santa antes
                de que trasladaran sus restos a Madrid, y la ermita de la Virgen de la Soledad (del siglo XVIII).
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 5-->
    <!--   Inicio Modal 6-->
    <b-modal
      id="modal6"
      centered
      scrollable
      size="lg"
      hide-footer
      title="Parque Arqueológico del Valle de los Neandertales (Pinilla del Valle)"
    >
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/visita-valle-de-los-neandertales/"
                  target="_blank"
                  alt="Más información sobre el Valle de los Neandertales"
                  >El Valle de los Neandertales</a
                >
                tiene como principal objetivo estudiar los yacimientos arqueopaleontológicos descubiertos en el Valle
                Alto del río Lozoya. Se trata de un
                <strong
                  >conjunto de siete yacimientos cársticos con cronologías que abarcan desde el último tercio del
                  Pleistoceno Medio hasta mediados del Pleistoceno Superior.</strong
                >
              </span>
            </li>
            <li>
              <span>
                Estos yacimientos contienen
                <strong
                  >registros tanto de los animales y la flora como de los humanos que vivieron en el Valle hace 100.000
                  años.</strong
                >
              </span>
            </li>
            <li>
              <span>
                Puede visitarse de martes a domingo, desde por la mañana hasta primera hora de la tarde. Cierra entre
                agosto y septiembre, durante las campañas de excavación.
              </span>
            </li>
            <li>
              <span>
                Consejo adicional: es <strong>imprescindible reservar plaza previamente,</strong> y acudir al punto de
                encuentro 15 minutos antes de la visita.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 6-->
    <!--    Fin de modal-->
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  components: {
    IconTime: () => import('../../components/iconos/IconTime'),
    // IconCulturetas: () => import('../../components/iconos/IconCulturetas'),
    // IconVerano: () => import('../../components/iconos/IconVerano'),
    // IconDistance: () => import('../../components/iconos/IconDistance'),
    IconFamilias: () => import('../../components/iconos/IconFamilias'),
    IconFoodies: () => import('../../components/iconos/IconFoodies'),
    IconInfluencers: () => import('../../components/iconos/IconInfluencers'),
    // IconInvierno: () => import('../../components/iconos/IconInvierno'),
    // IconOtono: () => import('../../components/iconos/IconOtono'),
    IconParejas: () => import('../../components/iconos/IconParejas'),
    // IconPrimavera: () => import('../../components/iconos/IconPrimavera'),
    IconTodasEstaciones: () => import('../../components/iconos/IconTodasEstaciones'),
    IconAventureros: () => import('../../components/iconos/IconAventureros')
  },
  mounted() {
    if (window.innerWidth > 1000) {
      const horizontalSlide = new TimelineMax().to('#scrollContainer', 1, { x: '-50%' })
      const scene = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '400%'
        })
        .setPin('#scroll-wrapper')
        .setTween(horizontalSlide)
      const scene2 = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '400%'
        })
        .setTween('#fondo-puntos', {
          width: '60%'
        })

      this.$scrollmagic.addScene(scene)
      this.$scrollmagic.addScene(scene2)
    }
  }
}
</script>
